import { Injectable } from '@angular/core';
import {AlertService} from '../alert/alert.service';
import {Participant} from '../model/Participant';
import {Observable} from 'rxjs/Observable';
import {Constants} from '../model/Constants';
import 'rxjs/add/operator/map';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class SpeakersService {

  constructor(private http: HttpClient,
              private alertServiceService: AlertService) { }

  getSpeakers(): Participant[] {
    return [
      {
        "id": 27,
        "firstName": "Rasha",
        "lastName": "Abu-Eid",
        "affiliation": "University of Aberdeen, UK"
      },
      {
        "id": 28,
        "firstName": "Grzegorz",
        "lastName": "Banaszak",
        "affiliation": "Adam Mickiewicz University, Poznań, Poland"
      },
      {
        "id": 31,
        "firstName": "Helmut",
        "lastName": "Ahammer",
        "affiliation": "University of Graz, Austria"
      },
      {
        "id": 32,
        "firstName": "Piotr",
        "lastName": "Krasoń",
        "affiliation": "Szczecin University, Poland"
      },
      {
        "id": 34,
        "firstName": "Tadeusz",
        "lastName": "Lulek",
        "affiliation": "Adam Mickiewicz University, Poznań, Poland"
      },
      {
        "id": 35,
        "firstName": "Preda",
        "lastName": "Mihailescu",
        "affiliation": "Georg-August-Universität, Göttingen, Germany"
      },
      {
        "id": 36,
        "firstName": "Jan",
        "lastName": "Milewski",
        "affiliation": "Poznań University of Technology, Poland"
      },
      {
        "id": 37,
        "firstName": "Nebojsa",
        "lastName": "Milosevic",
        "affiliation": "University of Belgrade, Serbia"
      },
      {
        "id": 38,
        "firstName": "Valery",
        "lastName": "Romanovski",
        "affiliation": "University of Maribor, Slovenia"
      },
      {
        "id": 39,
        "firstName": "Andrij",
        "lastName": "Rovenchak",
        "affiliation": "University of Lviv, Ukraine"
      },
      {
        "id": 40,
        "firstName": "Mihai",
        "lastName": "Tanase",
        "affiliation": "Georg-August-Universität, Göttingen, Germany"
      },
      {
        "id": 41,
        "firstName": "Herbert",
        "lastName": "Jelinek",
        "affiliation": "Charles Sturt University, Albury, Australia"
      },
      {
        "id": 44,
        "firstName": "Przemysław",
        "lastName": "Waliszewski",
        "affiliation": "Department of Urology, Lahn-Dill Clinics, Dillenburg"
      },
      {
        "id": 45,
        "firstName": "Andreas",
        "lastName": "Dominik",
        "affiliation": "THM University of Applied Sciences in Gießen, Germany"
      },
      {
        "id": 46,
        "firstName": "Dorota",
        "lastName": "Blinkiewicz",
        "affiliation": "Adam Mickiewicz University, Poznań, Poland"
      },
      {
        "id": 84,
        "firstName": "Maciej",
        "lastName": "Grześkowiak",
        "affiliation": "Adam Mickiewicz University in Poznań"
      },
      {
        "id": 85,
        "firstName": "Tomasz",
        "lastName": "Pawłowski",
        "affiliation": " Center for Theoretical Physics of the Polish Academy of Sciences"
      },
      {
        "id": 91,
        "firstName": "Veličko",
        "lastName": "Vraneš",
        "affiliation": "Área de Ciencias Básicas y Ambientales, Instituto Tecnológico de Santo Domingo, República Dominicana"
      },
      {
        "id": 101,
        "firstName": "Mirosław",
        "lastName": "Łabuz",
        "affiliation": "University of Rzeszów, Poland"
      }
    ];
  }

  private handleError(error: any) {
    this.alertServiceService.error('An error occurred: ', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/service/speakers.service.ts